/**
 * 用户中心api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();
export function getUser_center_v3() {
	/**查询用户的信息 */
	return api.get('/api/user_center_v3')
}
export function postUser_center_v3(params) {
	/**修改用户的信息 */
	return api.post('/api/user_center_v3', params)
}
export function reset_password_v3(params) {
	/**重置密码 */
	return api.post('/api/user_reset_password_v3', params)
}